import { Component } from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-onboarding-page-progress',
  imports: [
    TranslocoPipe
  ],
  templateUrl: './onboarding-page-progress.html',
  standalone: true,
  styleUrl: './onboarding-page-progress.scss'
})
export class OnboardingPageProgress {

}
